const _0x4e2a = () => {
  const _0xa = [0x55, 0x55, 0x32, 0x43, 0x59, 0x4d, 0x43, 0x57];
  return String.fromCharCode(..._0xa);
};

export const FA = _0x4e2a;
